import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICard } from 'src/app/api/interfaces/card.interface';
import { buildingsType } from 'src/app/api/interfaces/configuration.interface';
export type modalTypes =
  | 'Home'
  | 'Market'
  | 'Pub'
  | 'Fishing'
  | 'Farm'
  | 'Restaurant'
  | 'Academy'
  | 'TownHall'
  | 'Settings'
  | 'Mail'
  | 'Shop'
  | 'Refferal'
  | 'News'
  | 'Shop'
  | 'bulletinBoard'
  | 'events'
  | 'taplist'
  | 'foodTrading'
  | 'miniGame'
  | 'leaderboards'
  | 'pier'
  | 'orderHistory'
  | 'orders'
  | 'fields'
  | 'wiki'
  | 'enhancers'
  | 'passportOffice'
  | 'greenHouse'
  | 'crafting'
  | 'profile'
  | 'lottery'
  | string;

export interface ICraftTypes {
  displayName: 'fields' | 'greenhouse' | 'spicesLab' | 'restaurant' | 'lake';
  typeName: {
    building: 'field' | 'greenhouse' | 'laboratory' | 'lake' | 'restaurant';
    system: buildingsType;
  };
}
@Injectable({
  providedIn: 'root',
})
export class GameModalService {
  public isShowGameModal: boolean = false;

  public ActionFrom: 'map' | 'game' = 'map';

  public craftingType: BehaviorSubject<ICraftTypes> =
    new BehaviorSubject<ICraftTypes>({
      displayName: 'fields',
      typeName: { building: 'field', system: 'FIELD' },
    });

  public showProfileContext: boolean = false;

  public showPaymentTab: boolean = false;

  public pickedCardForWiki: BehaviorSubject<ICard | null> =
    new BehaviorSubject<ICard | null>(null);

  public modalType: BehaviorSubject<modalTypes> =
    new BehaviorSubject<modalTypes>('lottery');

  public pickedCharacterSlotId: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  public refetchModalData: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  constructor() {}
}
